import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';

const LikertScale = (props) => {
    const { start = 0, length = 0, userValue = 0 } = props;

    const scaleItems = [];

    for (let i = start, spanLength = length + start; i < spanLength; i += 1) {
        scaleItems.push(
            <span key={i} className={cns('likertScale-item', { selected: i === userValue })}>
                {i}
            </span>
        );
    }

    return <span className={'likertScale'}>{scaleItems}</span>;
};

LikertScale.propTypes = {
    start: PropTypes.number,
    length: PropTypes.number,
    userValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default LikertScale;
